import React from 'react';
import { useTheme } from '../hooks/useTheme';

const SunIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M8 1.5v1.6M8 12.9v1.6M1.5 8h1.6M12.9 8h1.6M3.4 3.4l1.1 1.1M11.5 11.5l1.1 1.1M3.4 12.6l1.1-1.1M11.5 4.5l1.1-1.1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

const MoonIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M6.2 2.4a5.6 5.6 0 1 0 7.4 7.4A4.8 4.8 0 1 1 6.2 2.4z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

function ThemeToggleButton({ className = 'app-nav-theme-toggle', variant, onAfterToggle }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';
  const icon = isLight ? <MoonIcon /> : <SunIcon />;
  const ariaLabel = isLight ? 'Включить тёмную тему' : 'Включить светлую тему';

  const handleClick = () => {
    toggleTheme();
    onAfterToggle?.();
  };

  if (variant === 'fab-row') {
    return (
      <button
        type="button"
        className={`app-nav-fab-account-row app-nav-fab-account-row--button app-nav-fab-theme-row${className ? ` ${className}` : ''}`}
        onClick={handleClick}
        aria-label={ariaLabel}
      >
        <span className="app-nav-fab-theme-icon" aria-hidden="true">{icon}</span>
        <span className="app-nav-fab-theme-label">Сменить тему</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      aria-label={ariaLabel}
      title={isLight ? 'Тёмная тема' : 'Светлая тема'}
    >
      {icon}
    </button>
  );
}

export default ThemeToggleButton;
